import { render, staticRenderFns } from "./simpleGoodsList.vue?vue&type=template&id=9d20b7f6&scoped=true"
import script from "./simpleGoodsList.vue?vue&type=script&lang=js"
export * from "./simpleGoodsList.vue?vue&type=script&lang=js"
import style0 from "./simpleGoodsList.vue?vue&type=style&index=0&id=9d20b7f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20b7f6",
  null
  
)

export default component.exports